import React from "react"

import { TweenMax, Expo, Quart } from 'gsap';

class IntroView extends React.Component {
    constructor(props) {
        super(props);
    }

	componentDidMount() {

	}

    animateIn(){
        TweenMax.set(this.introViewEl,{autoAlpha:1});
        TweenMax.staggerFromTo(this.introViewEl.querySelectorAll(".anim"),1,{opacity:0,y:30},{y:0,opacity:1,ease:Expo.easeOut,delay:0.5},0.05);
    }

    animateOut(){
        TweenMax.to(this.introViewEl,0.5,{autoAlpha:0});
    }

    onOperatorClick(){
        this.props.callback(0);
    }

    onFanClick(){
        this.props.callback(1);
    }

	render() {
		return (
        	
        	<div className="introView" ref={element => this.introViewEl = element}>
                <div className="title anim">
                    how do you<br/>make your<br/><span>impossible<br/>impact?</span>
                </div>
                <div className="buttons">
                    <div className="button anim" onClick={() => {this.onFanClick()}}>BY EATING IMPOSSIBLE</div>
                    <div className="button anim" onClick={() => {this.onOperatorClick()}}>BY SELLING IMPOSSIBLE</div>
                </div>
            </div>
        		
      	);
	}
}

export default IntroView;
